import asyncActionTypes from '../actions/types.js';

const initialState = {
  bannerCobrand: [],
};

const CobrandAffiliate = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_COBRANDCARD_AFFILIATE.START:
      return {
        ...state,
        bannerCobrand: [],
      };
    case asyncActionTypes.RETRIEVE_CMS_COBRANDCARD_AFFILIATE.SUCCESS:
      return {
        ...state,
        bannerCobrand: action.payload,
      };
    case asyncActionTypes.RETRIEVE_CMS_COBRANDCARD_AFFILIATE.FAIL:
      return {
        ...state,
        bannerCobrand: [],
      };
    default:
      return state;
  }
};

export default CobrandAffiliate;
